<template>
  <div>
    <disqualifier :orderStatus="43"/>
    <vxe-loading v-model="loading"/>
  </div>
</template>

<script>
import Disqualifier from '@/views/quality/disqualification/Disqualifier.vue'

export default {
  components: { Disqualifier },
  data() {
    return {
      loading: false
    }
  },
  methods: {}
}
</script>